import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { TWDataTable, EmptyState } from '../../../components/ui';
import { headerCls } from '../../../data/columns';
import { formatCurrency } from '../../../utils/baseUtils';
import ReferralStatusBadge from './ReferralStatusBadge';

dayjs.extend(utc);

const LEDGER_PAGE_SIZE = 10;

const columns = [
  {
    title: <span className={headerCls}>Date</span>,
    key: 'date',
    render: (_, row) => (
      <span className="text-sm text-slate-600 dark:text-slate-300">
        {row.createdate ? dayjs.utc(row.createdate).format('MMM D, YYYY') : '—'}
      </span>
    ),
  },
  {
    title: <span className={headerCls}>Type</span>,
    key: 'type',
    render: (_, row) => (
      <ReferralStatusBadge
        kind="ledger"
        code={row.type}
        fallbackLabel={row.typename}
      />
    ),
  },
  {
    title: <span className={headerCls}>Description</span>,
    key: 'description',
    render: (_, row) => (
      <span className="text-sm text-slate-600 dark:text-slate-300">
        {row.description || '—'}
      </span>
    ),
  },
  {
    title: <span className={`${headerCls} block text-right`}>Amount</span>,
    key: 'amount',
    align: 'right',
    render: (_, row) => {
      const positive = (row.amount || 0) >= 0;
      return (
        <span
          className={`text-sm font-semibold tabular-nums ${
            positive
              ? 'text-emerald-600 dark:text-emerald-400'
              : 'text-slate-700 dark:text-slate-300'
          }`}
        >
          {positive ? '+' : '−'}
          {formatCurrency(row.amount)}
        </span>
      );
    },
  },
];

// Ledger endpoint'i paging döndürmez -> tüm satırlar gelir, paging client-side.
const ReferralLedgerTable = ({ data, loading }) => {
  const [page, setPage] = useState(1);
  const rows = data || [];

  // Veri yeniden çekilince ilk sayfaya dön.
  useEffect(() => {
    setPage(1);
  }, [data]);

  if (!loading && rows.length === 0) {
    return (
      <EmptyState
        variant="dashed"
        title="No credit activity yet"
        description="Credit movements will appear here as you earn and use referral credit."
      />
    );
  }

  const pageRows = rows.slice(
    (page - 1) * LEDGER_PAGE_SIZE,
    page * LEDGER_PAGE_SIZE,
  );

  return (
    <TWDataTable
      columns={columns}
      data={pageRows}
      rowKey="id"
      loading={loading}
      pagination={
        rows.length > LEDGER_PAGE_SIZE
          ? {
              current: page,
              pageSize: LEDGER_PAGE_SIZE,
              total: rows.length,
              showSizeChanger: false,
              showTotal: (total, range) =>
                `Showing ${range[0]} to ${range[1]} of ${total} entries`,
              onChange: setPage,
            }
          : undefined
      }
    />
  );
};

export default ReferralLedgerTable;
